import Filters from './filters';

class Product {
	constructor() {
		if ($('[package="cms-product"]').length < 1) {
			return;
		}

		this.filters = new Filters();
	}
}
export default new Product();